import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaMapMarkerAlt, FaStar, FaInfoCircle, FaHistory, FaCamera } from "react-icons/fa";

// Import Local Assets
import img1 from "../../Assets/img/kandariya-mahadeva-temple-khajuraho.jpg";
import img2 from "../../Assets/img/chausath-yogini-temple-khajuraho.jpg";
import img3 from "../../Assets/img/chitragupta-temple-khajuraho.jpg";
import img4 from "../../Assets/img/vishwanath-temple-khajuraho.jpg";
import img5 from "../../Assets/img/lakshmana-temple-khajuraho.jpg";
import img7 from "../../Assets/img/matangeshwar-temple-khajuraho.jpg";
import img9 from "../../Assets/img/parshvanath-temple-khajuraho.jpg";
import img11 from "../../Assets/img/adinath-temple-khajuraho.jpg";
import img12 from "../../Assets/img/shantinath-temple-khajuraho.jpg";
import img13 from "../../Assets/img/dulhadev-temple-khajuraho.webp";

import { getMediaUrl } from "../../common/mediaUrl";
import { getVisits } from "../../slice/visitSlice";

const KhajurahoDetail = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: visits, loading } = useSelector((state) => state.visit);
  const [place, setPlace] = useState(null);

  useEffect(() => {
    dispatch(getVisits());
  }, [dispatch, i18n.language]);

  useEffect(() => {
    if (visits && visits.length > 0) {
      const found = visits.find((v) => v.id.toString() === id);
      setPlace(found);
      if (found) {
        window.scrollTo(0, 0);
      }
    }
  }, [visits, id]);

  if (loading || !place) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FCFBFA]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-main"></div>
      </div>
    );
  }

  const images = (() => {
    try {
      return JSON.parse(place.images);
    } catch (e) {
      return [];
    }
  })();

  // Combined All Attractions with Local Static Images
  const allAttractions = [
    {
      title: "KANDARIYA MAHADEO",
      description: "A UNESCO World Heritage Site Kandariya Mahadeva is the largest and most ornate of the Hindu temples and is renowned for its Nagara-style architecture (characterized by a central tower), as well as its sculpture . Kandariya Mahadeva was constructed about 1017-1029 by King Ganda, one of their greatest figures. The temple is dedicated to the Hindu deity Lord Shiva. The erotic sculptures are concentrated on the northern and southern façade. Other themes of sculpture in the temple include- warriors and hunters, acrobats, musicians, dancers, devotees and famous couples.",
      staticImg: img1
    },
    {
      title: "CHOUNSATH YOGNI",
      description: "The Temple of Chausath Yogini in Khajuraho is built on a large raised podium which itself is set in an open courtyard with small temples surrounding it. It is these shrines that are devoted to the Yoginis. This Temple dedicated to Ladies God Kali . .",
      staticImg: img2
    },
    {
      title: "CHITRAGUPTA TEMPLE",
      description: "The Chitragupta Temple is the only temple in the whole of Khajuraho . Built by Chandela rulers in1023 AD, Chitragupta Temple is dedicated to Sun God. The temple houses a beautiful 5 feet high standing idol of Lord Surya driving a chariot, which is pulled by seven horses. Three similar figures are also carved on the door lintel. The south wall of the temple displays an eleven-headed Vishnu carving, which possesses ten different avatars of Lord Vishnu. Apart from this, intricate carvings of processions, dancing girls, elephant fights and hunting scenes are also adorned the temple walls.",
      staticImg: img3
    },
    {
      title: "VISHWANATH TEMPLE",
      description: "The 11th century-built Vishwanath Temple is believed to be commissioned by Emperor Dhanga of the Chandela Dynasty. The temple is dedicated to Shiva and has a beautiful marble Shiva Linga inside the sanctorum. It is entirely covered in carved figurines from the shikhara to the lower base platform. The beauty of the temple lies in the beautiful depiction of women on the stone wall. The magnificent carvings on the outer walls make its beautiful texture more attractive. There is also a huge 6-foot statue of Nandi bull sitting on a large platform.",
      staticImg: img4
    },
    {
      title: "LAKSHMANA TEMPLE",
      description: "A UNESCO World Heritage Site Kandariya Mahadeva is the largest and most ornate of the Hindu temples and is renowned for its Nagara-style architecture (characterized by a central tower), as well as its sculpture . Kandariya Mahadeva was constructed about 1017-1029 by King Ganda, one of their greatest figures. The temple is dedicated to the Hindu deity Lord Shiva. The erotic sculptures are concentrated on the northern and southern façade. Other themes of sculpture in the temple include- warriors and hunters, acrobats, musicians, dancers, devotees and famous couples.",
      staticImg: img5
    },
    {
      title: "MATANGESWARA TEMPLE",
      description: "Still a living place of worship, This Temple dedicated to Lord Shiva. Matanga manifested in from of lingam, and controlled the God of Love. It is not richly decorated; its interior walls, exterior walls and curvilinear tower and devoid of Carvings.",
      staticImg: img7
    },
    {
      title: "PARSVANATH TEMPLE",
      description: "Parsvanth Temple is 10th century Jain Temple at Khajuraho. The Sculptures on the northern outer wall are particularly noteworthy. It is now dedicate to Parsavanath . It was built as an Adhinatha shrine during the Chandela Period.",
      staticImg: img9
    },
    {
      title: "GHANTAL TEMPLE",
      description: "The has a frieze which depicts the 16 dreams of Mahavira’s Mother’s and a Jain Goddess on a winged a Garuda.",
      staticImg: img11
    },
    {
      title: "ADHINATH TEMPLE",
      description: "This Temple dedicated the Jain Saint Adhinath. This Temple exterior wall also features Hindu Deities. The Exterior Wall of the Temple of three bands of sculptures featuring graceful Woman. The Three Hindu Temples of the group are the Barhma, containing a four-faced lingam, the Vamana, which is adomed on its outer walls with carving apsaras in veriety of sensous attides and the Javari. Another sculpture with similar iconography also features a yaksha, a yakshini, and a bull with a dharmachakra.",
      staticImg: img12
    },
    {
      title: "DULADEO TEMPLE",
      description: "This Temple known as Kunwar Math, Dulhadev Temple is dedicated to Lord Shiva. As per the evidences Duladeo Temple was built by King Madanvarman of the Chandela dynasty in 1130 AD. Duladeo Temple is not as ornate. It is inferred that the name is of the chief sculptor who created the sculptures.",
      staticImg: img13
    },
    {
      title: "CHATURBHUJ TEMPLE",
      description: "Chaturbhuj Temple is a Hindu temple dedicated to the God Vishnu. This temple is also known as Jatakari Temple as it is situated in the village of Jatakari. The temple was built by Yasovarman of the Chandela Dynasty in c. 1100 CE.",
      staticImg: img1
    },
    {
      title: "SOUND & LIGHT SHOW",
      description: "The Light & Sound Show Evening Activity for Tourist .This shows in 50 minutes Hindi & English the journey of Chandravarman, the Great Chandela king and the history, facts and myths of Khajuraho Routess efficiently. Amitabh Bachchan the Indian Super Star, narrates the story of Khajuraho in his mesmerising voice.",
      staticImg: img2
    }
  ];

  const activeGroup = allAttractions;

  return (
    <main className="w-full min-h-screen bg-[#FCFBFA] font-sans selection:bg-orange-100 selection:text-orange-900 pb-20">
      <Helmet>
        <title>{`${t(place.name)} | Khajuraho Routes`}</title>
        <meta name="description" content={`Learn more about ${t(place.name)} in Khajuraho. ${t(place.description).substring(0, 120)}...`} />
        <meta name="keywords" content={`${t(place.name)}, Khajuraho temples, Khajuraho attractions, ${t(place.name)} details`} />
        <link rel="canonical" href={`https://khajurahoroutes.com/khajuraho/${id}`} />

        {/* Open Graph */}
        <meta property="og:type" content="place" />
        <meta property="og:url" content={`https://khajurahoroutes.com/khajuraho/${id}`} />
        <meta property="og:title" content={`${t(place.name)} | Khajuraho Routes`} />
        <meta property="og:description" content={`Learn more about ${t(place.name)} in Khajuraho. ${t(place.description).substring(0, 120)}...`} />
        {images.length > 0 && <meta property="og:image" content={getMediaUrl(images[0])} />}

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${t(place.name)} | Khajuraho Routes`} />
        <meta name="twitter:description" content={`Learn more about ${t(place.name)} in Khajuraho. ${t(place.description).substring(0, 120)}...`} />
        {images.length > 0 && <meta name="twitter:image" content={getMediaUrl(images[0])} />}

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "TouristAttraction",
              "name": "${t(place.name)}",
              "image": "${images.length > 0 ? getMediaUrl(images[0]) : 'https://khajurahoroutes.com/logo.png'}",
              "description": "${t(place.description).replace(/"/g, '\\"').substring(0, 200)}",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Khajuraho",
                "addressRegion": "Madhya Pradesh",
                "addressCountry": "IN"
              }
            }
          `}
        </script>
      </Helmet>
      
      {/* ─── FLOATING BACK BUTTON ─── */}
      <section className="relative h-[40vh] md:h-[50vh] w-full bg-black flex items-start pt-20 md:pt-28 overflow-hidden">
        <img 
          src={getMediaUrl(images[0])} 
          className="absolute inset-0 w-full h-full object-cover opacity-60" 
          alt={t(place.name)} 
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FCFBFA] via-transparent to-transparent" />
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white/80 hover:text-orange-main transition-colors mb-6 group"
          >
            <FaArrowLeft className="text-[12px]" />
            <span className="text-[10px] font-bold uppercase tracking-widest">{t('khajurahodetail_go_back')}</span>
          </motion.button>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <h1 className="text-3xl md:text-6xl font-black text-orange-main uppercase tracking-tight leading-tight">
              {t(place.name)}
            </h1>
          </motion.div>
        </div>
      </section>

      {/* ZIG-ZAG ATTRACTIONS SECTION */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {activeGroup.map((item, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-10 md:gap-20 mb-20 md:mb-32 last:mb-0`}
            >
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="w-full md:w-1/2"
              >
                <h2 className="text-2xl md:text-3xl font-black text-gray-900 uppercase leading-tight mb-6">
                  {item.title.split(' ').slice(0, -1).join(' ')} <span className="text-orange-main">{item.title.split(' ').slice(-1)}</span>
                </h2>
                <p className="text-gray-600 text-base leading-relaxed font-medium">
                  {item.description}
                </p>
              </motion.div>
              <motion.div 
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                className="w-full md:w-1/2"
              >
                <img 
                  src={item.staticImg} 
                  className="w-full aspect-[16/10] object-cover rounded-3xl shadow-2xl" 
                  alt={t(item.title)} 
                />
              </motion.div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default KhajurahoDetail;
